export class RuntimeConfig {
  ENVIRONMENT_KEY?: 'development' | 'test' | 'acceptance' | 'production' | string;
  BUILD_ID?: string;
  SOURCE_VERSION?: string;
  LOGGING_SENTRY_DSN?: string;
  CLARITY_PROJECT_ID?: string;
  ANALYTICS_CONSOLE_LOGGING?: boolean;
}
